import groupService from '../../services/group-service';
import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';
import FileChooser from '../widgets/file-chooser/FileChooser';

import './UploadPictureDialog.scss';

export interface Props extends DialogProps {
  groupId: string;
}

class UploadPictureDialog extends DialogComponent<Props> {

  state = {
    file: null,
    isUploading: false,
    uploadPercent: 0,
    error: ''
  }

  render() {
    const { uploadPercent, isUploading } = this.state;
    const display = isUploading ? 'flex' : 'none';
    return (
      <div className="upload-picture-dialog-component">
        <FileChooser
          hint="تصویر مورد نظر را انتخاب کنید (حداکثر ۲ مگابایت)"
          minHeight="200px"
          iconSize="3rem"
          onChoose={this.handleChooseFile} />
        <div className="progress" style={{ display }}>
          <div
            className="progress-bar bg-success"
            role="progressbar"
            style={{ width: uploadPercent + '%' }}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={uploadPercent}>
            <span>{uploadPercent}% Completed</span>
          </div>
        </div>
        <button
          {...this.buttonDisableAttr()}
          onClick={this.handleUploadClick}
          className="btn ant-btn-primary btn-block mt-3">آپلود فایل</button>
      </div>
    );
  }

  buttonDisableAttr = () => {
    const { file, isUploading } = this.state;
    if (isUploading || file == null) {
      return { disabled: true };
    }
    return {};
  }

  handleChooseFile = (file: File) => {
    this.setState({ file });
  }

  handleUploadClick = () => {
    const { groupId } = this.props;
    this.setState({ isUploading: true }, () => {
      const form = new FormData();
      form.append('media', this.state.file);
      try {
        groupService.uploadMedia(groupId, form, {
          onProcess: (_e, percent) => this.setState({ uploadPercent: percent }),
          onComplete: () => {
            this.setState({ uploadPercent: 100, isUploading: false, error: '' });
            this.close();
          }
        });
      }
      catch (e) {
        let update = { isUploading: false };
        if (e.message) {
          update = { ...update, ...{ error: e.message } };
        }
        this.setState(update);
        console.error(e);
      }
    });
  }

}

export default UploadPictureDialog;
